<template>
  <DropDown title="Change Language" class="flex items-center">
    <template v-slot:button>
      <span class="flex items-center flex-row flex-nowrap text-xs hoverBtn">
        <span v-if="showTitle">Change Language</span>
        <svg
          width="18"
          height="18"
          viewBox="0 0 512 512"
          fill="#ff5505"
          xmlns="http://www.w3.org/2000/svg"
          class="cursor-pointer"
        >
          <title>Change Language</title>
          <path
            d="M478.33,433.6l-90-218a22,22,0,0,0-40.67,0l-90,218a22,22,0,1,0,40.67,16.79L316.66,406H419.33l18.33,44.39A22,22,0,0,0,458,464a22,22,0,0,0,20.32-30.4ZM334.83,362,368,281.65,401.17,362Z"
          />
          <path
            d="M267.84,342.92a22,22,0,0,0-4.89-30.7c-.2-.15-15-11.13-36.49-34.73,39.65-53.68,62.11-114.75,71.27-143.49H330a22,22,0,0,0,0-44H214V70a22,22,0,0,0-44,0V90H54a22,22,0,0,0,0,44H251.25c-9.52,26.95-27.05,69.5-53.79,108.36-31.41-41.68-43.08-68.65-43.17-68.87a22,22,0,0,0-40.58,17c.58,1.38,14.55,34.23,52.86,83.93.92,1.19,1.83,2.35,2.74,3.51-39.24,44.35-77.74,71.86-93.85,80.74a22,22,0,1,0,21.07,38.63c2.16-1.18,48.6-26.89,101.63-85.59,22.52,24.08,38,35.44,38.93,36.1a22,22,0,0,0,30.75-4.9Z"
          />
        </svg>
      </span>
    </template>
    <template v-slot:content>
      <el-radio class="py-1" v-model="locale" @change="changedLang" label="fa">
        Persian
      </el-radio>
      <el-radio class="py-1" v-model="locale" @change="changedLang" label="en">
        English
      </el-radio>
    </template>
  </DropDown>
</template>
<script>
import DropDown from '@/components/elements/dropDown.vue'
export default {
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      lang: 'fa',
    }
  },
  computed: {
    locale: {
      get() {
        return this.$i18n.locale
      },
      set(val) {
        this.$store.dispatch('changeLocale', val)
        this.$router.replace({ params: { lang: val } })
      },
    },
    test() {
      return this.$router
    },
  },
  methods: {
    changedLang() {
      this.show = false
    },
    hide() {
      this.show = false
    },
  },

  components: {
    DropDown,
  },
}
</script>
